export const sortTableColumns = (
  columns: Array<{ id?: string; isStatic?: boolean }>,
  savedColumnOrder?: Record<string, number>,
) => {
  if (!savedColumnOrder) {
    return columns;
  }

  return columns.sort((a, b) => {
    if (a.isStatic && !b.isStatic) {
      return -10000;
    }
    if (b.isStatic && !a.isStatic) {
      return 10000;
    }
    return (savedColumnOrder[a.id!] ?? 1000) - (savedColumnOrder[b.id!] ?? 1000);
  });
};
